/**
 * Filial doirasi (owner va bir nechta filialli menejer): sahifa sarlavhasida segmentli tanlov -- "Hammasi · Main · KSU…".
 * Yuqori panel hamma rol uchun bir xil, doira esa sahifaga tegishli (redesign v2). Qiymat app/branchFilter.ts da
 * saqlanadi: Home, Drivers, Pipeline, Reports va Budget bir xil tanlovni ko'radi. Filial ko'p bo'lsa -- ro'yxat.
 */
import { useTranslation } from "react-i18next";
import { canPickBranch, useBranchFilter, scopedBranch } from "@/app/branchFilter";
import type { Me } from "@/features/auth/types";
import { useBranchOptions } from "@/features/dashboards/api";
import { Segmented } from "@/components/ui/segmented";
import { Select } from "@/components/ui/field";

const SEGMENT_MAX = 5;

export function ScopePicker({ me, className }: { me: Me; className?: string }) {
  const { t } = useTranslation();
  const { branchId, setBranchId } = useBranchFilter();
  const isOwner = me.role === "owner";
  const branches = useBranchOptions(isOwner && canPickBranch(me));
  if (!canPickBranch(me)) return null;
  const options = isOwner ? (branches.data?.results ?? []) : me.scope_branches;
  const value = scopedBranch(me, branchId) ?? 0;
  const allLabel = t(isOwner ? "scope.all" : "myBranches");
  if (options.length <= SEGMENT_MAX) {
    return (
      <Segmented<string>
        ariaLabel={t("scope.label")}
        className={className}
        value={String(value)}
        onChange={(v) => setBranchId(v === "0" ? null : Number(v))}
        options={[{ value: "0", label: allLabel }, ...options.map((b) => ({ value: String(b.id), label: b.name }))]}
      />
    );
  }
  return (
    <Select value={value || ""} onChange={(e) => setBranchId(e.target.value ? Number(e.target.value) : null)} className={className ?? "w-auto min-w-[160px]"} aria-label={t("scope.label")}>
      <option value="">{allLabel}</option>
      {options.map((b) => (
        <option key={b.id} value={b.id}>
          {b.name}
        </option>
      ))}
    </Select>
  );
}
